import {
  companyMock,
  customerMock,
  FpTheme,
  jobMock,
  PrimaryTheme
} from '@flicent/fieldpulse-react-component-library-frontend';

import { MetaData } from './interfaces';


export const MOCK_META_DATA: MetaData = {
  'customer': customerMock,
  'company': companyMock,
  'jobs': [
    jobMock,
  ]
};

export const MOCK_THEME: FpTheme = PrimaryTheme;